var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{attrs:{"bordered":false}},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("优惠、免费政策")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }